import { Toast } from '@byecode/ui'
import { ErrorMessage, getAuthorize, getImageFullUrlInCommon, UploadManageContext } from '@lighthouse/shared'
import { useUpdateEffect } from '@react-hookz/web'
import React, { useCallback, useMemo, useRef } from 'react'
import { Controller, useForm } from 'react-hook-form'

import { tokenRefreshManager } from '@/http'
import { uploadPublicParams } from '@/utils/auth'

import { Header } from '../Header'
import * as SC from './styles'
import type { SpaceDataProps, SpaceForm } from './types'
import { UploadBtn } from './UploadButton'

export const SpaceData: React.FC<SpaceDataProps> = ({ workspace, onUpdate }) => {
    const submitEl = useRef<HTMLInputElement>(null)
    // const [data, setData] = useState<WorkSpaceAbstract>(workspace)
    const { id: spaceId, createdTime, members, icon = '', name, createdBy, roleId } = workspace
    const spaceInformationManager = useMemo(() => getAuthorize(roleId || '', 'spaceInformationManager'), [roleId])

    const {
        handleSubmit,
        getValues,
        reset,
        control,
        formState: { errors }
    } = useForm<SpaceForm>({
        reValidateMode: 'onChange',
        shouldFocusError: false,
        values: {
            icon: icon,
            name: name
        }
    })

    useUpdateEffect(() => {
        reset({
            icon: icon,
            name: name
        })
    }, [spaceId])

    const handleUpdateSubmit = useCallback(
        async (formData: SpaceForm) => {
            const param = {
                ...workspace,
                name: formData.name,
                icon: formData.icon
            }
            const isSuccess = await onUpdate(param)
            if (isSuccess) {
                Toast.success('修改成功')
            }
        },
        [workspace, onUpdate]
    )

    const readySubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
        return submitEl.current?.click()
    }

    return (
        <SC.Container>
            <SC.SpaceInfo>
                <Header title="资料" />
                <SC.SpaceForm
                    onSubmit={(ev: React.FormEvent) => {
                        ev.preventDefault()
                        handleSubmit(handleUpdateSubmit)()
                    }}
                >
                    <SC.FormGroup>
                        <SC.FormLabel>头像</SC.FormLabel>
                        <Controller
                            control={control}
                            name="icon"
                            render={({ field: { value, onChange } }) => (
                                <UploadManageContext accept="image/*" {...uploadPublicParams()} tokenRefreshManager={tokenRefreshManager}>
                                    <UploadBtn
                                        name={getValues('name')}
                                        disabled={!spaceInformationManager}
                                        img={value ? getImageFullUrlInCommon(value) : undefined}
                                        radius="8px"
                                        onUpdateImg={onChange}
                                    />
                                </UploadManageContext>
                            )}
                        />
                    </SC.FormGroup>
                    <SC.FormGroup>
                        <SC.FormLabel>空间名</SC.FormLabel>
                        <Controller
                            control={control}
                            name="name"
                            rules={{ required: '请输入空间名' }}
                            render={({ field: { value, onChange } }) => (
                                <ErrorMessage name="name" errors={errors} style={{ flex: 1 }}>
                                    <SC.FormInput
                                        disabled={!spaceInformationManager}
                                        maxLength={20}
                                        placeholder="请输入空间名"
                                        value={value}
                                        onChange={onChange}
                                    />
                                </ErrorMessage>
                            )}
                        />
                    </SC.FormGroup>
                    <SC.HideSubmit ref={submitEl} type="submit" />
                    <SC.FormGroup>
                        <SC.FormLabel>空间创建于</SC.FormLabel>
                        <SC.FormContent>{createdTime}</SC.FormContent>
                    </SC.FormGroup>
                    <SC.FormGroup>
                        <SC.FormLabel>空间人数</SC.FormLabel>
                        <SC.FormContent>{members}人</SC.FormContent>
                    </SC.FormGroup>
                    <SC.FormGroup>
                        <SC.FormLabel>空间拥有者</SC.FormLabel>
                        <SC.FormContent>{createdBy}</SC.FormContent>
                    </SC.FormGroup>
                    <SC.Footer>
                        {spaceInformationManager && (
                            <SC.OkBtn size="md" type="primary" radius={7} onClick={readySubmit}>
                                保存设置
                            </SC.OkBtn>
                        )}
                    </SC.Footer>
                </SC.SpaceForm>
            </SC.SpaceInfo>
        </SC.Container>
    )
}
